'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'chess-king-piece';
var width = 320;
var height = 512;
var aliases = ["chess-king-alt"];
var unicode = 'f440';
var svgPathData = 'M136 96l0-40-16 0c-13.3 0-24-10.7-24-24S106.7 8 120 8l16 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 16 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 40 78.1 0c14.3 0 25.9 11.6 25.9 25.9 0 4-.9 8-2.7 11.6l-33.4 66.8c11.4 1.8 20.2 11.7 20.2 23.7 0 13.3-10.7 24-24 24l-5.6 0 13.6 136 56.2 70.3c5 6.3 7.8 14.1 7.8 22.2 0 19.6-15.9 35.5-35.5 35.5L35.5 512c-19.6 0-35.5-15.9-35.5-35.5 0-8.1 2.7-15.9 7.8-22.2L64 384 77.6 248 72 248c-13.3 0-24-10.7-24-24 0-11.9 8.7-21.9 20.2-23.7L34.7 133.5c-1.8-3.6-2.7-7.6-2.7-11.6 0-14.3 11.6-25.9 25.9-25.9L136 96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChessKingPiece = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;